import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface ScorecardEmptyStateProps {
  icon?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
  titleClassName?: string;
  descriptionClassName?: string;
}

const ScorecardEmptyState = ({
  icon,
  title,
  description,
  action,
  className,
  titleClassName,
  descriptionClassName,
}: ScorecardEmptyStateProps) => (
  <div className={cn("rounded-lg border border-dashed border-border/80 text-center", className)}>
    {icon ? icon : null}
    {title ? (
      <p className={cn("text-sm font-medium text-foreground", titleClassName)}>{title}</p>
    ) : null}
    {description ? (
      <p className={cn("text-xs text-muted-foreground", descriptionClassName)}>{description}</p>
    ) : null}
    {action}
  </div>
);

export default ScorecardEmptyState;
